module.exports = __webpack_public_path__ + "media/images/jamicons/check-7d11e6cdb4b4d7abcf90b905e29be8f9.svg";